import React from 'react';
import PropTypes from 'prop-types';
import { Search } from 'semantic-ui-react';

import './BlogSearch.css';
import { BlogPostPropType } from '../../../../services/proptypes';

export default class BlogSearch extends React.PureComponent {
  render() {
    const { value, onResultSelect, onSearchChange, searchResults, loading } = this.props;

    return (
      <div className="blog-search">
        <Search
          value={value}
          loading={loading}
          onResultSelect={onResultSelect}
          onSearchChange={onSearchChange}
          results={searchResults.map(({ title, slug }) => ({ title, slug }))}
          placeholder="Search Blog"
          minCharacters={3}
          showNoResults={false}
        />
      </div>
    );
  }
}

BlogSearch.propTypes = {
  value: PropTypes.string,
  onResultSelect: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  searchResults: PropTypes.arrayOf(BlogPostPropType),
  loading: PropTypes.bool,
};

BlogSearch.defaultProps = {
  value: '',
  searchResults: [],
  loading: false,
};
